import { render } from "./BaseNumberField.vue?vue&type=template&id=0cf5cb20&scoped=true"
import script from "./BaseNumberField.vue?vue&type=script&lang=js"
export * from "./BaseNumberField.vue?vue&type=script&lang=js"

import "./BaseNumberField.vue?vue&type=style&index=0&id=0cf5cb20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf5cb20"]])

export default __exports__